// SEARCH

jQuery(document).ready(function($){

  $('.c-share').click(function() {
    $(this).children('ul').toggleClass('active');

    var button = $(this).children('button').first();
    var ariaExpanded = button.attr('aria-expanded');
    if (ariaExpanded === 'true')
      button.attr('aria-expanded', 'false');
    else
      button.attr('aria-expanded', 'true');
  });

});
